/******************************************
 * emartmall
 *
 * @author          Luke.kim
 * @copyright       Copyright (c) 2013 emart.
 * @license         This is dual licensed under the MIT and GPL licenses.
 * @version         0.1
 * @description     수정시에는 modify 태그에 수정부분에 대한 설명을 적을것, 코드 수정 이후에는 수정자가 코드 품질 보장.
 * @since           2013-08-29 10:04
 * @modify          2013-09-25 11:09
 * @uses            jindo.m
 * @history 0.1.2   공통 모듈로 따로 뽑아 파일 생성
 *
 ******************************************/
var oSupport = (function (m) {

    'use strict';

    var _htDeviceInfo = m.getDeviceInfo(),
        _bIsAndroid = _htDeviceInfo.android,
        _aVersion = _htDeviceInfo.version,
        _isCss3dUse = function () {
            var _bUseCss3d = m._isUseCss3d();

            if (_bIsAndroid && "4" === _aVersion[0]) {
                _bUseCss3d = true;
            }

            if (_bUseCss3d && (_htDeviceInfo.galaxyNote || _htDeviceInfo.galaxyS3 || (navigator.userAgent.indexOf("LG-") > -1))) {
                _bUseCss3d = false;
            }

            return _bUseCss3d;
        },
        _getDeviceReadyTime = function () {
            return m.getDeviceInfo().android ? 1000 : 0;
        };
    return {
        "bUseCss3d": _isCss3dUse(),
        "nReadyTime": _getDeviceReadyTime()
    };
})(jindo.m);